import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import {
  faInstagram,
  faReddit,
  faTiktok,
  faTwitch,
  faXTwitter
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="w-full border-t border-divider py-0">
      <div className="flex min-h-6 w-full items-center justify-between gap-2 px-2">
        <div className="flex items-center gap-2">
          <Link
            to="https://thedmsark.com/privacy-policy"
            target="_blank"
            className="flex items-center border-r border-divider pr-2">
            <span className="text-xs opacity-70 transition-opacity hover:opacity-100">
              Privacy Policy
            </span>
          </Link>
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="https://instagram.com/thedmsark"
            target="_blank"
            className="flex items-center border-r border-divider text-xs opacity-70 transition-opacity hover:opacity-100">
            <FontAwesomeIcon icon={faInstagram} className="mr-2" />
          </Link>
          <Link
            to="https://tiktok.com/@thedmsark"
            target="_blank"
            className="flex items-center border-r border-divider text-xs opacity-70 transition-opacity hover:opacity-100">
            <FontAwesomeIcon icon={faTiktok} className="mr-2" />
          </Link>
          <Link
            to="https://x.com/thedmsark"
            target="_blank"
            className="flex items-center border-r border-divider text-xs opacity-70 transition-opacity hover:opacity-100">
            <FontAwesomeIcon icon={faXTwitter} className="mr-2" />
          </Link>
          <Link
            to="https://www.reddit.com/r/thedmsark"
            target="_blank"
            className="flex items-center border-r border-divider text-xs opacity-70 transition-opacity hover:opacity-100">
            <FontAwesomeIcon icon={faReddit} className="mr-2" />
          </Link>
          <Link
            to="https://www.twitch.tv/thedmsark"
            target="_blank"
            className="flex items-center border-divider text-xs opacity-70 transition-opacity hover:opacity-100">
            <FontAwesomeIcon icon={faTwitch} className="mr-2" />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
